import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DragDropContext, Droppable, DropResult } from "react-beautiful-dnd";
import { PiEyesFill } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import * as S from "./styles";
import Card from "../../components/Card";
import AddCardButton from "../../components/AddCardButton";
import favicon from "../../assets/favicon.png";
import {
  initFormEtcs,
  CardProps,
  FormProps,
  initCards,
  InputTypes,
  ItemTypeProps,
  moveCard,
  moveContent,
  SectionProps,
  setRequiredCardId,
  StateProps,
  editPartnerLink,
  editPartnerImage,
  editPartnerName,
  editCompleteText,
  editCompleteTitle,
  FormEtcProps,
} from "../../store";
import AddPartnerImage from "../../components/AddPartnerImage";
import CompleteInputBox from "../../components/CompleteInputBox";
import Preview from "../Preview";
import { API_URL } from "../../config";

const initialSections: SectionProps[] = [
  {
    formSectionId: "new=section",
    sectionTitle: "",
    isTitle: true,
    cards: [
      {
        id: "new=1",
        cardTitle: "신청서 제목입니다.",
        inputType: InputTypes.TITLE,
        contents: [],
        subText: "",
        placeholder: "",
        isRequired: false,
        lengthMin: 0,
        isFocused: false,
      },
    ],
  },
  {
    formSectionId: "sectionform=1",
    sectionTitle: "기본",
    isTitle: false,
    cards: [
      {
        id: "sectionform=1=1",
        cardTitle: "이름",
        inputType: InputTypes.NAME,
        contents: [],
        subText: "",
        placeholder: "홍길동",
        isRequired: true,
        lengthMin: 0,
        isFocused: false,
      },
      {
        id: "sectionform=1=2",
        cardTitle: "연락처",
        inputType: InputTypes.CONTACT,
        contents: [],
        subText: "",
        placeholder: "",
        isRequired: true,
        lengthMin: 0,
        isFocused: false,
      },
    ],
  },
  {
    formSectionId: "sectionform=2",
    sectionTitle: "참가신청서",
    isTitle: false,
    cards: [
      {
        id: "sectionform=2=1",
        cardTitle: "지원동기",
        inputType: InputTypes.TEXTAREA,
        contents: [],
        subText: "",
        placeholder: "",
        isRequired: true,
        lengthMin: 0,
        isFocused: false,
      },
    ],
  },
  {
    formSectionId: "sectionform=3",
    sectionTitle: "동의서 및 안내사항",
    isTitle: false,
    cards: [
      {
        id: "sectionform=3=1",
        cardTitle: "개인정보 수집 및 이용 동의서",
        inputType: InputTypes.RADIO,
        contents: [{ id: "sectionform=3=1=1", text: "동의합니다." }],
        subText:
          "신청서에 작성한 본인은 <strong>OOOO, </strong>한달살러가 「개인정보보호법」제15조(개인정보의 수집·이용) 및 제17조(개인정보의 제공) 규정에 의거하여 다음 개인정보를 수집·이용 및 제3자에 제공하는데 동의합니다." +
          "<br><br> 수집하는 개인정보 항목 : " +
          "<br> 수집 및 이용 목적 : " +
          "<br> 보유 및 이용기간 :  작성일로부터 - 간 (행사 완료 후 파기)",

        placeholder: "",
        isRequired: true,
        lengthMin: 0,
        isFocused: false,
      },
    ],
  },
];

const Form = () => {
  const { cards } = useSelector((state: StateProps) => state);
  const { formEtcs } = useSelector((state: StateProps) => state);
  const dispatch = useDispatch();
  const { programId } = useParams();
  const [customUrl, setCustomUrl] = useState("");
  const [initialCustomUrl, setInitialCustomUrl] = useState("");
  const [accessKey, setAccessKey] = useState("");
  const [imageAlert, setImageAlert] = useState(false);
  const [linkAlert, setLinkAlert] = useState(false);
  const [completeTitleAlert, setCompleteTitleAlert] = useState(false);
  const [partnerNameAlert, setPartnerNameAlert] = useState(false);
  const [customUrlAlert, setCustomUrlAlert] = useState(false);
  const [createStatus, setCreateStatus] = useState(false);
  const navigate = useNavigate();
  const [editInitCards, setEditInitCards] = useState<CardProps[]>([]);
  const [editInitFormEtcs, setEditInitFormEtcs] = useState<FormEtcProps>();
  const [editState, setEditState] = useState(false);

  const openPreviewTab = () => {
    const url = `/form/preview`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    // 페이지를 떠날 때 경고 메시지를 표시합니다.
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isChanged()) {
        event.preventDefault();
        // eslint-disable-next-line no-param-reassign
        event.returnValue = "123";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload, { capture: true });

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload, { capture: true });
    };
  }, [editState]); // dependencies로 customUrl과 initialCustomUrl을 추가하여 isChanged 상태를 추적

  useEffect(() => {
    const handleUserActivity = () => {
      setEditState((prevState) => !prevState);
    };

    document.addEventListener("click", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);

    return () => {
      document.removeEventListener("click", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
    };
  }, []);

  const isChanged = () => {
    console.log(`customUrl: ${customUrl}, initialCustomUrl: ${initialCustomUrl}`);
    console.log(`editInitFormEtcs: ${editInitFormEtcs}, formEtcs: ${formEtcs}`);
    console.log(`editInitCards: ${editInitCards}, cards: ${cards}`);

    if (customUrl !== initialCustomUrl) {
      console.log("customUrl is changed");
      return true;
    }

    if (editInitFormEtcs === undefined || formEtcs === undefined) return true;
    if (editInitFormEtcs.partnerLink !== formEtcs.partnerLink) {
      console.log("partnerLink is changed");
      return true;
    }
    if (editInitFormEtcs.partnerImage !== formEtcs.partnerImage) {
      console.log("partnerImage is changed");
      return true;
    }
    if (editInitFormEtcs.partnerName !== formEtcs.partnerName) {
      console.log("partnerName is changed");
      return true;
    }
    if (editInitFormEtcs.completeTitle !== formEtcs.completeTitle) {
      console.log("completeTitle is changed");
      return true;
    }
    if (editInitFormEtcs.completeText !== formEtcs.completeText) {
      console.log("completeText is changed");
      return true;
    }

    if (editInitCards.length !== cards.length) {
      console.log("length is different");
      return true;
    }

    for (let i = 0; i < editInitCards.length; i += 1) {
      if (editInitCards[i].id !== cards[i].id) {
        console.log("id is different");
        return true;
      }
      if (editInitCards[i].cardTitle !== cards[i].cardTitle) {
        console.log("cardTitle is different");
        return true;
      }
      if (editInitCards[i].inputType !== cards[i].inputType) {
        console.log("inputType is different");
        return true;
      }
      if (editInitCards[i].subText !== cards[i].subText) {
        console.log("subText is different");
        return true;
      }
      if (editInitCards[i].placeholder !== cards[i].placeholder) {
        console.log("placeholder is different");
        return true;
      }
      if (editInitCards[i].isRequired !== cards[i].isRequired) {
        console.log("isRequired is different");
        return true;
      }
      if (editInitCards[i].lengthMin !== cards[i].lengthMin) {
        console.log("lengthMin is different");
        return true;
      }

      if (
        editInitCards[i].inputType === InputTypes.CHECKBOX ||
        editInitCards[i].inputType === InputTypes.RADIO ||
        editInitCards[i].inputType === InputTypes.SELECT
      ) {
        const initContents = editInitCards[i].contents as ItemTypeProps[];
        const contents = cards[i].contents as ItemTypeProps[];

        if (initContents.length !== contents.length) return true;

        for (let j = 0; j < initContents.length; j += 1) {
          if (initContents[j].text !== contents[j].text) return true;
          if (initContents[j].isEtc !== contents[j].isEtc) return true;
          if (initContents[j].id !== contents[j].id) return true;
        }
      }
    }

    return false;
  };

  useEffect(() => {
    //  TEST
    // setAccessKey("");
    // localStorage.setItem(
    //   "accessKey",
    //   "",
    // );

    // 메시지 수신
    const handleMessage = (event: MessageEvent) => {
      // 보낸 페이지의 origin 확인
      const { accessKey } = event.data;
      if (accessKey !== null && accessKey !== undefined) {
        setAccessKey(accessKey);
        localStorage.setItem("accessKey", accessKey);
      }
    };
    window.addEventListener("message", handleMessage);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!accessKey) {
        alert("로그인 정보가 없습니다. 신청 페이지로 이동합니다.");
        navigate(`/form/apply/${programId}`);
      } else {
        const authority = hasAuthority();
        authority.then((res) => {
          if (!res) {
            alert(
              `programId: ${programId} 에 대한 접근 권한이 없습니다. 신청 페이지로 이동합니다.`,
            );
            navigate(`/form/apply/${programId}`);
          }
        });
      }
    }, 2000);
    // 컴포넌트가 언마운트 될 때 타이머를 정리
    return () => clearTimeout(timer);
  }, [accessKey]);

  const hasAuthority = async () => {
    const response = await axios.get(`${API_URL}/admin/authority/${programId}`, {
      headers: {
        Authorization: `Bearer ${accessKey}`,
      },
    });

    return response.data.result;
  };

  useEffect(() => {
    // Fetch data from the server
    console.log("fetch data from the server");

    const cards = [] as CardProps[];

    getSectionProps().then((res) =>
      res.forEach((section) => {
        section.cards.forEach((card) => {
          cards.push(card);
        });
        dispatch(initCards(cards));
      }),
    );

    setEditInitCards(cards);
    setEditState(!editState);
  }, []);

  const getSectionProps = async () => {
    const response = await axios
      .get(`${API_URL}/forms/${programId}`)
      .then((res) => res)
      .catch((err) => err.response);

    let form = {} as FormProps;
    const newSections: SectionProps[] = [];

    dispatch(
      initFormEtcs({
        partnerLink: "",
        partnerImage: "",
        partnerName: "",
        completeTitle: "",
        completeText: "",
      }),
    );

    if (response.status !== 200) {
      setCustomUrl("");
      setCreateStatus(true);

      form = {
        formId: "firstFormId",
        programId: programId!,
        partnerLink: "",
        partnerImage: "",
        partnerName: "",
        completeTitle: "",
        completeText:
          "소중한 지원 감사합니다.<br/>" +
          "신청 결과는 <strong>00월 00일에 개별문자로 전달될 예정</strong>입니다.<br/><br/>" +
          "[문의처]<br/>" +
          "연락 방법을 작성해주세요.",
        programTitle: "firstProgram",
        sections: initialSections,
      };
    } else {
      form = response.data as FormProps;
    }

    dispatch(editPartnerLink({ partnerLink: form.partnerLink }));
    dispatch(editPartnerImage({ partnerImage: form.partnerImage || "" }));
    dispatch(editPartnerName({ partnerName: form.partnerName }));
    dispatch(editCompleteTitle({ completeTitle: form.completeTitle }));
    dispatch(editCompleteText({ completeText: form.completeText || "" }));
    setCustomUrl(form.customUrl ?? "");
    setInitialCustomUrl(form.customUrl ?? "");
    setEditInitFormEtcs({
      partnerLink: form.partnerLink,
      partnerImage: form.partnerImage || "",
      partnerName: form.partnerName,
      completeTitle: form.completeTitle,
      completeText: form.completeText || "",
    } as FormEtcProps);

    form.sections.forEach((section) => {
      const newCards: CardProps[] = [];

      if (!section.isTitle) {
        newCards.push({
          id: `${section.formSectionId}-sectionid`,
          cardTitle: section.sectionTitle,
          inputType: getSectionType(section.teamNumber),
          contents: [],
          subText: "",
          placeholder: "",
          isRequired: false,
          lengthMin: section.teamNumber,
          isFocused: false,
        });
      } else {
        newCards.push({
          id: `${section.formSectionId}-titleSection`,
          cardTitle: section.sectionTitle,
          inputType: getSectionType(section.teamNumber),
          contents: [],
          subText: "",
          placeholder: "",
          isRequired: false,
          lengthMin: section.teamNumber,
          isFocused: false,
        });
      }

      section.cards.forEach((card) => {
        if (card.inputType === InputTypes.CHECKBOX) {
          const contents = card.contents as ItemTypeProps[];
          const newContents = [] as ItemTypeProps[];
          contents?.forEach((content) => {
            const newId = `${content.id}-${content.text}`;
            newContents.push({
              id: newId,
              text: content.text,
              isEtc: content.isEtc,
            });
          });
          newCards.push({
            id: `${card.id.toString()}-id`,
            cardTitle: card.cardTitle,
            inputType: card.inputType,
            contents: newContents,
            subText: card.subText,
            placeholder: card.placeholder,
            isRequired: card.isRequired,
            lengthMin: card.lengthMin,
            isFocused: false,
          });
        } else {
          const contents = card.contents as ItemTypeProps[];
          const newContents = [] as ItemTypeProps[];
          contents?.forEach((content) => {
            const newId = `${content.id.toString()}-contentId`;
            newContents.push({
              id: newId,
              text: content.text,
              isEtc: content.isEtc,
            });
          });
          newCards.push({
            id: `${card.id.toString()}-id`,
            cardTitle: card.cardTitle,
            inputType: card.inputType,
            contents: newContents,
            subText: card.subText,
            placeholder: card.placeholder,
            isRequired: card.isRequired,
            lengthMin: card.lengthMin,
            isFocused: false,
          });
        }
      });
      newSections.push({
        formSectionId: section.formSectionId,
        sectionTitle: section.sectionTitle,
        isTitle: section.isTitle,
        cards: newCards,
        teamNumber: section.teamNumber,
      });
    });

    return newSections;
  };

  const getSectionType = (teamNumber: number | undefined) => {
    if (teamNumber == null) {
      return InputTypes.SECTION;
    }
    if (teamNumber >= 1) {
      return InputTypes.ADDABLE_SECTION;
    }
    return InputTypes.SECTION;
  };

  const create = () => () => {
    console.log("create form");
    validation(cards);

    const sections = [] as SectionProps[];
    let sectionOrder = 0;
    let cardOrder = 0;

    cards.forEach((card) => {
      if (card.inputType === InputTypes.SECTION || card.inputType === InputTypes.ADDABLE_SECTION) {
        let length = card.lengthMin;

        if (card.inputType === InputTypes.SECTION) {
          length = undefined;
        }
        if (
          card.inputType === InputTypes.ADDABLE_SECTION &&
          (card.lengthMin === undefined || card.lengthMin === null || card.lengthMin === 0)
        ) {
          length = 1;
        }

        sections.push({
          formSectionId: getRealId(card.id),
          sectionTitle: card.cardTitle,
          isTitle: sectionOrder === 0,
          teamNumber: length,
          cards: [],
          order: sectionOrder,
        });
        sectionOrder += 1;
      } else if (
        card.inputType === InputTypes.CHECKBOX ||
        card.inputType === InputTypes.RADIO ||
        card.inputType === InputTypes.SELECT
      ) {
        const lastSection = sections[sections.length - 1];
        const contents = [] as ItemTypeProps[];
        let contentsOrder = 0;

        (card.contents as ItemTypeProps[]).forEach((content) => {
          contents.push({
            id: getRealId(content.id),
            text: content.text,
            isEtc: content.isEtc,
            order: contentsOrder,
          });
          contentsOrder += 1;
        });

        if (lastSection) {
          lastSection.cards.push({
            id: getRealId(card.id),
            cardTitle: card.cardTitle,
            inputType: card.inputType,
            contents,
            subText: card.subText,
            placeholder: card.placeholder,
            isRequired: card.isRequired,
            lengthMin: card.lengthMin,
            isFocused: false,
            order: cardOrder,
          });
          cardOrder += 1;
        }
      } else {
        const lastSection = sections[sections.length - 1];
        if (lastSection) {
          lastSection.cards.push({
            id: getRealId(card.id),
            cardTitle: card.cardTitle,
            inputType: card.inputType,
            subText: card.subText,
            placeholder: card.placeholder,
            isRequired: card.isRequired,
            lengthMin: card.lengthMin,
            isFocused: false,
            order: cardOrder,
          });
          cardOrder += 1;
        }
      }
    });

    if (sections.map((section) => section.cards.length === 0).includes(true)) {
      const emptySection = sections.find((section) => section.cards.length === 0);
      alert("비어있는 섹션이 있습니다. 제목에 속하는 하위 항목들을 추가해주세요.");
      const element = document.getElementById(`${emptySection?.formSectionId ?? ""}-sectionid`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // 해당 태그 위치로 스크롤
        dispatch(setRequiredCardId({ cardId: `${emptySection?.formSectionId ?? ""}-sectionid` }));
      }
      return;
    }

    const form = {
      programId,
      partnerLink: formEtcs.partnerLink,
      partnerImage: formEtcs.partnerImage,
      partnerName: formEtcs.partnerName,
      completeTitle: formEtcs.completeTitle,
      completeText: formEtcs.completeText,
      customUrl,
      sections,
    };

    axios
      .put(`${API_URL}/forms/${programId}`, form, {
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (createStatus) {
            alert("신청서가 성공적으로 생성되었습니다.");
            setCreateStatus(false);
            setInitialCustomUrl(customUrl);
            setEditInitFormEtcs(formEtcs);

            // formCardId, formSectionId, formContentsId 초기화

            const cardsWithIds = [] as CardProps[];

            getSectionProps().then((res) => {
              console.log(res);
              res.forEach((section) => {
                section.cards.forEach((card) => {
                  cardsWithIds.push(card);
                });
                dispatch(initCards(cardsWithIds));
                setEditInitCards(cardsWithIds);
              });
            });
          } else {
            alert("신청서가 성공적으로 편집되었습니다.");
            setInitialCustomUrl(customUrl);
            setEditInitFormEtcs(formEtcs);
            setEditInitCards(cards);
          }
        }
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          alert(error.response?.data?.message || error.message);
        } else {
          alert(error instanceof Error ? error.message : String(error));
        }
        throw new Error(`신청서 생성에 실패했습니다. 다시 시도해주세요. ${error}`);
      });
  };

  const requiredCardIds = useSelector((state: StateProps) => state.required as string[]);

  const validation = (cards: CardProps[]) => {
    let errorLocation = -1;
    let errorId = "";
    let nameOrContactError = false;
    let urlError = false;

    if (customUrl !== initialCustomUrl) isDuplicate(customUrl);

    console.log("requiredCardIds", requiredCardIds);

    setImageAlert(false);
    setLinkAlert(false);

    if (formEtcs.partnerImage === "") {
      setImageAlert(true);
      errorLocation = 0;
    }

    if (formEtcs.partnerLink === "") {
      setLinkAlert(true);
      errorLocation = 0;
    }

    if (formEtcs.completeTitle === "") {
      setCompleteTitleAlert(true);
      if (errorLocation === -1) errorLocation = 10;
    }

    if (formEtcs.partnerName === "") {
      setPartnerNameAlert(true);
      if (errorLocation === -1) errorLocation = 10;
    }

    const titleSectionCard = cards.find(
      (card) => card.inputType === InputTypes.SECTION && card.id.split("-")[1] === "titleSection",
    );
    if (titleSectionCard?.cardTitle === "") {
      dispatch(setRequiredCardId({ cardId: titleSectionCard.id }));
      errorLocation = 0;
    }

    cards.forEach((card) => {
      if (card.cardTitle === "") {
        dispatch(setRequiredCardId({ cardId: card.id }));
        if (errorId === "") {
          errorId = card.id;
        }
      }
      if (card.contents !== undefined && card.contents instanceof Array) {
        (card.contents as ItemTypeProps[]).forEach((content) => {
          if (content.text === "") {
            dispatch(setRequiredCardId({ cardId: content.id }));
            if (errorId === "") {
              errorId = card.id;
            }
          }
        });
      }
      if (
        card.inputType === InputTypes.ADDABLE_SECTION &&
        (card.lengthMin == null || card.lengthMin === 0)
      ) {
        dispatch(setRequiredCardId({ cardId: card.id }));
        if (errorId === "") {
          errorId = card.id;
        }
      }
    });

    const alphanumericRegex = /^[a-zA-Z0-9]+$/;
    const numericOnlyRegex = /^[0-9]+$/;

    if (
      (customUrl !== "" && !alphanumericRegex.test(customUrl)) ||
      numericOnlyRegex.test(customUrl) ||
      customUrl.length > 30
    ) {
      setCustomUrlAlert(true);
      errorLocation = 0;
      urlError = true;
    }

    const nameCard = cards.find((card) => card.inputType === InputTypes.NAME);
    const contactCard = cards.find((card) => card.inputType === InputTypes.CONTACT);

    if (nameCard === undefined || contactCard === undefined) {
      nameOrContactError = true;
    }

    if (errorLocation !== -1 || errorId !== "" || nameOrContactError || urlError) {
      if (errorLocation === 0) {
        window.scrollTo({ top: 0, behavior: "smooth" }); // 페이지 상단으로 스크롤
      } else if (errorId !== "") {
        const element = document.getElementById(errorId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" }); // 해당 태그 위치로 스크롤
        }
      } else if (errorLocation === 10) {
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" }); // 페이지 하단으로 스크롤
      } else if (nameOrContactError) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }

    if (urlError) {
      alert("커스텀 url은 30자 이내의 영문, 숫자 조합만 입력 가능합니다.");
      throw new Error("커스텀 url은 30자 이내의 영문과 숫자만 입력 가능합니다.");
    } else if (errorLocation !== -1 || errorId !== "") {
      alert("필수 입력란을 확인해주세요.");
      throw new Error("필수 입력란을 확인해주세요.");
    } else if (nameOrContactError) {
      alert("이름과 연락처 문항은 필수 문항입니다.");
      throw new Error("이름과 연락처는 필수 문항입니다.");
    }
  };

  const checkCustomUrl = (url: string) => {
    // 숫자와 영문자만 허용하는 정규 표현식
    const alphanumericRegex = /^[a-zA-Z0-9]+$/;
    // 숫자만으로 이루어진 문자열을 확인하는 정규 표현식
    const numericOnlyRegex = /^[0-9]+$/;

    // URL이 비어 있지 않고, 알파벳이나 숫자로만 이루어져 있지 않거나, 숫자만으로 이루어졌거나, 길이가 30자를 초과하는 경우
    if (
      url !== "" &&
      (!alphanumericRegex.test(url) || numericOnlyRegex.test(url) || url.length > 30)
    ) {
      setCustomUrlAlert(true);
    } else {
      setCustomUrlAlert(false);
    }
  };

  const isDuplicate = async (url: string) => {
    const response = await axios.get(`${API_URL}/forms/exists/check-url?customUrl=${url}`);
    if (response.data.result) {
      alert("중복된 url path 입니다.");
      setCustomUrlAlert(true);
      setCustomUrl("");
      throw new Error("중복된 url path 입니다.");
    }
  };

  const getRealId = (id: string) => {
    const ids = id.split("-");
    if (ids.length === 2 && ids[0].split("=").length < 2) {
      return ids[0];
    }
    return "-1";
  };

  const onDragEnd = ({ destination, source }: DropResult) => {
    if (!destination) {
      return;
    }
    if (source.droppableId === "card" && destination.index === 0) {
      return;
    }
    if (source.droppableId === "card") {
      dispatch(
        moveCard({
          sourceIndex: String(source.index),
          destinationIndex: String(destination.index),
        }),
      );
    } else if (destination.droppableId === source.droppableId) {
      dispatch(
        moveContent({
          cardId: source.droppableId,
          sourceIndex: String(source.index),
          destinationIndex: String(destination.index),
        }),
      );
    }
  };

  return (
    <>
      <S.Header>
        <S.UrlPath>
          (선택) 원하는 링크 https://monthler-form.monthler.kr/form/apply/
          <S.UrlInput
            id="standard-basic"
            variant="standard"
            placeholder={programId}
            value={customUrl}
            alert={customUrlAlert}
            onChange={(e) => {
              setCustomUrl(e.target.value);
              checkCustomUrl(e.target.value);
              setEditState(!editState);
            }}
            onBlur={() => {
              if (customUrl !== "" && customUrl !== initialCustomUrl) {
                isDuplicate(customUrl);
              }
            }}
          />
        </S.UrlPath>
        {/* {createStatus ? <S.Edit color="blue">생성</S.Edit> : <S.Edit color="#000">편집</S.Edit>} */}
        <S.FabButton
          onClick={() => {
            openPreviewTab();
          }}
        >
          <PiEyesFill style={{ width: 28, height: "auto" }} />
        </S.FabButton>
        {!createStatus ? (
          <S.ApplyButton
            onClick={() => {
              window.open(
                `/form/apply/${initialCustomUrl !== "" ? initialCustomUrl : programId}`,
                "_blank",
              );
            }}
          >
            <img src={favicon} alt="신청서바로가기" style={{ width: 26, height: "auto" }} />
          </S.ApplyButton>
        ) : null}
      </S.Header>
      <S.FormContainer>
        <AddPartnerImage
          imageAlert={imageAlert}
          linkAlert={linkAlert}
          setImageAlert={setImageAlert}
          setLinkAlert={setLinkAlert}
        />
        <DragDropContext onDragEnd={onDragEnd}>
          <S.Container>
            <Droppable droppableId="card" type="card" direction="vertical">
              {(provided) => (
                <div>
                  <S.CardList {...provided.droppableProps} ref={provided.innerRef}>
                    {cards.map((card, idx) => (
                      <Card
                        key={card.id}
                        idx={idx}
                        isTitle={card.inputType === InputTypes.TITLE}
                        {...card}
                      />
                    ))}
                  </S.CardList>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            <AddCardButton save={create()} />
          </S.Container>
        </DragDropContext>
        <S.Complete>
          <S.CompleteTitle>신청완료 후 확인화면</S.CompleteTitle>
          <CompleteInputBox
            completeTitleAlert={completeTitleAlert}
            setCompleteTitleAlert={setCompleteTitleAlert}
          />
        </S.Complete>
        <S.PartnerName>
          이 프로그램은{" "}
          <S.PartnerNameInput
            id="standard-basic"
            variant="standard"
            placeholder="대표 브랜드명"
            value={formEtcs.partnerName}
            alert={partnerNameAlert}
            onChange={(e) => {
              dispatch(editPartnerName({ partnerName: e.target.value }));
              setPartnerNameAlert(false);
            }}
          />
          에서 진행합니다.
        </S.PartnerName>
        <S.PreviewSubmitSection>
          <S.SubmitButton type="button" onClick={create()}>
            {createStatus ? "신청서 만들기 완료" : "편집 완료"}
          </S.SubmitButton>
        </S.PreviewSubmitSection>
      </S.FormContainer>
    </>
  );
};

export default Form;
